import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Space, Tag } from 'tdesign-react';
import { connect } from 'react-redux';
import { modifyHosts, removeHost } from '@/slices/execScriptSlice';
import OperateTitle from '../../components/OperateTitle';
import SelectHostModal from './Modal';

function SelectHost({ cluster, modifyHosts, hosts, removeHost }) {
  const [visible, setVisible] = useState(false);

  const handleClose = (rows) => {
    setVisible(false);
    if (rows) {
      modifyHosts(rows);
    }
  };

  return (
    <Root className='fadeIn'>
      <OperateTitle
        label='第二步：'
        title='选择目标机器'
        operator={
          <Button variant='outline' theme='primary' onClick={() => setVisible(true)}>
            选择机器
          </Button>
        }
      />
      <Content>
        <Title>
          已选择：<Text $empty={hosts.length === 0}>{hosts.length}台</Text>
        </Title>
        <Scroll className='narrow-scrollbar'>
          <Space breakLine size={[8, 10]}>
            {hosts.map((host) => (
              <Tag
                theme='success'
                key={host.id}
                onClose={() => removeHost(host.id)}
                variant='light-outline'
                closable
              >
                {host.serviceIp || host.hostIp}
              </Tag>
            ))}
          </Space>
        </Scroll>
      </Content>
      <SelectHostModal visible={visible} clusterId={cluster.id} handleClose={handleClose} />
    </Root>
  );
}

export default connect(
  (state) => ({
    cluster: state.execScript.cluster,
    hosts: state.execScript.hosts,
  }),
  {
    modifyHosts,
    removeHost,
  },
)(SelectHost);

const Root = styled.div`
  border-radius: 8px;
  border: 1px solid #e1e1e1;
  margin-bottom: 16px;
`;

const Content = styled.div`
  overflow-y: auto;
  padding: 12px 20px;
  box-sizing: border-box;
`;

const Title = styled.div`
  color: var(--td-text-color-primary);
  font-family: PingFang SC;
  font-size: 14px;
  margin-bottom: 10px;
`;

const Text = styled.span`
  ${(props) => props.$empty && `color:  var(--td-error-color);`}
`;

const Scroll = styled.div`
  max-height: 106px;
  min-height: 30px;
  overflow-y: auto;
`;
